/* @flow */

import * as React from 'react';
import type {FieldProps} from 'redux-form';
import {RangeInput} from 'shells/range-input';

type Props = {
    label: string,
    min: number,
    max: number,
    disabled?: boolean,
    ...$Exact<FieldProps>,
};

export function ReduxFormSlider(props: Props) {
    const {input, ...restProps} = props;

    return <RangeInput {...input} {...restProps} />;
}
